import { Moon, Sun } from 'lucide-react';
import type { ThemeMode } from '../../lib/theme';

/** Light/Dark switcher for the two Design pages (Verein and Plattform) —
 * every color-ish field below it (Farben, Antwort-Buttons, and the
 * Hintergrundbild card's flat-color fallback) is edited independently per
 * mode; switching tabs only changes which of the two already-loaded states
 * is shown, nothing is saved or reset by switching. */
export function ModeTabs({ mode, onChange }: { mode: ThemeMode; onChange: (mode: ThemeMode) => void }) {
  return (
    <div className="inline-flex rounded-lg border border-slate-200 bg-slate-100 p-1 dark:border-slate-700">
      {(
        [
          ['light', 'Light Mode', Sun],
          ['dark', 'Dark Mode', Moon],
        ] as const
      ).map(([value, label, Icon]) => (
        <button
          key={value}
          type="button"
          onClick={() => onChange(value)}
          className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
            mode === value ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'
          }`}
        >
          <Icon size={14} />
          {label}
        </button>
      ))}
    </div>
  );
}
